import React from "react";
import "../animations/animate.css";

const About = () => {
    return (
        <section
            className="relative z-10 w-full items-center justify-center overflow-hidden bg-[#0E1016] bg-cover bg-center pt-16 pb-26 md:pt-20 md:pb-14 lg:pt-20 lg:pb-26"
            id="about"
        >
            <div className="mx-auto flex w-[90%] flex-col items-center justify-center lg:max-w-[1212.8px]">
                <h2 className="mb-10 w-full text-left text-[40px] font-bold leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px]">
                    About Me
                </h2>

                <div className="mx-auto flex w-[100%] flex-col lg:max-w-[1200px] lg:flex-row lg:gap-20">
                    <div className="mb-10 flex w-[100%] flex-col gap-4 text-[18px] font-medium leading-relaxed tracking-wide text-[#e4ded7] md:mb-16 md:gap-6 md:text-[20px] md:leading-relaxed lg:mb-16 lg:max-w-[90%] lg:text-[24px]">
                        <p>Senior Web Engineer with 5+ years of experience building production web applications with React and Next.js, specializing in the back of the frontend — integrating APIs, optimizing SSR/ISR delivery, and ensuring performance at scale.</p>

                        <p>Experienced in developing and delivering high-impact frontends connected to GraphQL APIs, headless CMS platforms, and third-party services. Strong focus on accessibility (WCAG), web security, and performance optimization (Core Web Vitals).</p>

                        <p>Comfortable working across distributed teams, collaborating with design, backend, and infrastructure to ship reliable, scalable user-facing systems.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
